import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React, { FC } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CustomDialogStyles from "./CustomDialogStyles";
import { useTranslation } from "react-i18next";

type onClose = () => void;

interface props {
  open: boolean;
  maxWidth: "lg" | "md" | "sm" | "xl" | "xs";
  onClose: onClose;
  title?: string;
  content?: React.ReactNode;
  actions?: React.ReactNode;
  showDivider: boolean;
  isRichTextContent?: boolean;
}

const CustomDialog: FC<props> = ({
  open,
  maxWidth,
  onClose,
  title,
  content,
  actions,
  showDivider,
  isRichTextContent,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog 
      id="DialogBox_dialog"
      data-test-id="test-DialogBox_dialog"
      aria-label="Dialog Box"
      open={open} 
      maxWidth={maxWidth} 
      onClose={onClose} 
      fullWidth
    >
      {title ? (
        <>
          <DialogTitle 
            id="DialogBox_title"
            data-test-id="test-DialogBox_title"
            aria-label="Dialog Title"
            sx={CustomDialogStyles.commonDialogTitle}
          >
            <Typography>{t(title)}</Typography>
            <CloseIcon
              id="DialogBox_close-button"
              data-test-id="test-DialogBox_close-button"
              aria-label="Close Dialog"
              onClick={onClose} 
              sx={{ cursor: "pointer" }} 
            />
          </DialogTitle>
          {showDivider ? <Divider /> : <></>}
        </>
      ) : (
        <></>
      )}
      <DialogContent 
        id="DialogBox_content"
        data-test-id="test-DialogBox_content"
        aria-label="Dialog Content"
        sx={CustomDialogStyles.commonDialogContent}
      >
        {isRichTextContent ? (
          <Box
            id="DialogBox_rich-content"
            data-test-id="test-DialogBox_rich-content"
            aria-label="Rich Text Content"
            dangerouslySetInnerHTML={{
              __html:
                typeof content === "string" ? content : String(content || ""),
            }}
          />
        ) : (
          content
        )}
      </DialogContent>
      {showDivider ? <Divider /> : <></>}
      {actions ? (
        <DialogActions 
          id="DialogBox_actions"
          data-test-id="test-DialogBox_actions"
          aria-label="Dialog Actions"
          sx={{ padding: actions ? "6px" : "20px" }}
        >
          {actions}
        </DialogActions>
      ) : (
        <></>
      )}
    </Dialog>
  );
};

export default CustomDialog;
